var render = function render(){var _vm=this,_c=_vm._self._c;return _c('utility-detail-link',{ref:"utilityDetailLink",attrs:{"detailLayout":_vm.detailLayout,"utilityData":_vm.utilityData,"utilityKey":_vm.utilityKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }